<template>
    <div class="gz-block-subtitle">
        <div class="gz-block-subtitle__side"></div>
        <div class="gz-block-subtitle__container">
            <span class="gz-block-subtitle__title" :style="bold ? 'font-weight: 600' : ''">{{ title }}</span>
        </div>
        <div class="gz-block-subtitle__side"></div>
    </div>
</template>

<script>
export default {
    name: 'BlockTitle',

    props: {
        title: {
            type: String
        },
        bold: Boolean
    }
}
</script>